import './style.css';
import { initWeather, selectWeatherLocation, toggleWeather } from './weather.js';
import { initCommunityReport } from './helpers/community_report.js';
import { Map, Overlay, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM, { ATTRIBUTION } from 'ol/source/OSM.js';
import { Attribution, Control, ScaleLine, defaults as defaultControls } from 'ol/control.js';
import XYZ from 'ol/source/XYZ';
import proj4 from 'proj4';
import { register } from "ol/proj/proj4";
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import GeoJSON from 'ol/format/GeoJSON.js';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import LayerGroup from 'ol/layer/Group';
import TileWMS from 'ol/source/TileWMS.js';
import Static from 'ol/source/ImageStatic.js';

import LayerSwitcher from 'ol-layerswitcher';
import { BaseLayerOptions, GroupLayerOptions } from 'ol-layerswitcher';

import { pattern, waldreservate_styles } from './helpers/styles/waldreservate_style';
import { protectionAreaStyleFunction } from './helpers/styles/protection_areas_style';
import { communityReportStyleFunction } from './helpers/styles/community_reports_style';
import { droneRestrictions_stylesFunction } from './helpers/styles/drone_restriction_style';
import { aviationObstacles_stylesFunction } from './helpers/styles/aviation_obstacles_styles';
import { airFields_stylesFunction } from './helpers/styles/airfields_styles';
import { hospitalAirFields_stylesFunction } from './helpers/styles/hospital_styles';
import { mountainAirfields_stylesFunction } from './helpers/styles/mountain_airfields_styles';
import ImageLayer from 'ol/layer/Image';
import { fromLonLat } from 'ol/proj';
import Layer from 'ol/layer/Layer';
import CustomOverlay from './CustomOverlay.js';
import Select from 'ol/interaction/Select';
import { altKeyOnly, click, pointerMove, singleClick, always } from 'ol/events/condition.js';

/*
_________ .__            ____  __.            ___.    
\_   ___ \|  |__   ____ |    |/ _| ____   ____\_ |__  
/    \  \/|  |  \_/ __ \|      <  /    \ /  _ \| __ \ 
\     \___|   Y  \  ___/|    |  \|   |  (  <_> ) \_\ \
 \______  /___|  /\___  >____|__ \___|  /\____/|___  /
        \/     \/     \/        \/    \/           \/ 
*/


// let coords = [47.51592, 8.64225];
// let coords = [2690860, 1263705]
// let coords = [46.144397003532859, 6.029030502468904]
// let coords = [6.029030502468904, 46.144397003532859];
// let coords = [8.732604921065677, 47.49629643959691]
// let lang;

let langs = ["en", "de", "fr", "it"];

if (lang === undefined) {
  lang = langs[0];
}

console.log(lang);

let coords = [8.222665776, 46.800663464];
coords = proj4("EPSG:4326", "EPSG:3857", coords);
let center = [coords[0] - 0.2, coords[1]];



// console.log(coords);
var lastZoom = 10;
const LAYER_SELECTION_STORAGE_KEY = 'swiss-drone-map.layer-selection.v1';

proj4.defs(
  "EPSG:2056",
  "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs"
);
register(proj4);

// Reprojected WMTS layer from map.geo.admin.ch
var createLayer = function (layername, timestam, fileformat, visibility, opacity) {
  return new TileLayer({
    type: 'base',
    visible: visibility,
    title: layername.replace('ch.swisstopo.', '') + ` - ${opacity}`,
    opacity: opacity / 100,
    zIndex: 0,
    source: new XYZ({
      attributions: '<a target="new" href="https://www.swisstopo.admin.ch/">data and map &copy; swisstopo</a>',
      opaque: false,
      url: `https://wmts.geo.admin.ch/1.0.0/${layername}/default/current/3857/{z}/{x}/{y}.${fileformat}`
    })
  });
}
// https://leaflet-tilelayer-swiss.karavia.ch/layers.html
const colorBaseLayerSwissTopo = createLayer('ch.swisstopo.pixelkarte-farbe', 'current', 'jpeg', false, 100);
const swTLM3dBaseLayerSwissTopo = createLayer('ch.swisstopo.swisstlm3d-karte-grau', 'current', 'png', false, 100);
const clrTLM3dBaseLayerSwissTopo = createLayer('ch.swisstopo.swisstlm3d-karte-farbe', 'current', 'png', false, 100);
const swWinterLayerSwissTopo = createLayer('ch.swisstopo.pixelkarte-farbe-winter', 'current', 'jpeg', false, 100);
const swBaseLayerSwissTopo = createLayer('ch.swisstopo.pixelkarte-grau', 'current', 'jpeg', false, 100);
const swBase50LayerSwissTopo = createLayer('ch.swisstopo.pixelkarte-grau', 'current', 'jpeg', true, 50);
const colorBase50LayerSwissTopo = createLayer('ch.swisstopo.pixelkarte-farbe', 'current', 'jpeg', false, 50);


const styleFunction = function (feature) {
  return waldreservate_styles[feature.getGeometry().getType()];
};

const styleFunctionObstacles = function (feature) {
  return aviationObstacles_stylesFunction(feature, map.getView().getZoom());
};

const styleFunctionAirFields = function (feature) {
  return airFields_stylesFunction(feature, map.getView().getZoom());
};

const styleFunctionHospitalAirFields = function (feature) {
  return hospitalAirFields_stylesFunction(feature, map.getView().getZoom());
};

const styleFunctionMountainAirfields = function (feature) {
  return mountainAirfields_stylesFunction(feature, map.getView().getZoom());
};

// let overlay = new Overlay({
//   id: 'parking_spots',
//   visible: true,
//   title: 'parking spots',
//   position: center,
//   positioning: 'center-center',
//   element: document.getElementById('app_feature2'),
//   stopEvent: false,
//   zIndex: 10000,
// });

// let parkingSpots = new Layer({
//   title: 'parking spots',
//   visible: false,
//   source: overlay
// });

const easyFlyZone30 = new TileLayer({
  title: 'Easy Fly Zone 30m Distance',
  visible: false,
  source: new TileWMS({
    url: 'https://qgis.bko.li/ogc/drones?',
    params: { 'LAYERS': 'headachefree_dronezone_30', 'TILED': true },
    serverType: 'geoserver',
    transition: 0,
  }),
});

const easyFlyZone150 = new TileLayer({
  title: 'Easy Fly Zone 150m Distance',
  visible: false,
  source: new TileWMS({
    url: 'https://qgis.bko.li/ogc/drones?',
    params: { 'LAYERS': 'headachefree_dronezone_150', 'TILED': true },
    serverType: 'geoserver',
    transition: 0,
  }),
});

// local UAS activity zones (cantonal/municipal) — added 2026-05-22
const localUasZones = new VectorLayer({
  style: droneRestrictions_stylesFunction,
  title: 'Local UAS Zones',
  visible: false,
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.bazl.uas-aktivitaetszonen.geojson',
    format: new GeoJSON()
  })
})

const localMunicipalityRestrictions = new VectorLayer({
  style: droneRestrictions_stylesFunction,
  title: 'Local municipality restrictions',
  visible: false,
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.local.drone-restrictions.geojson',
    format: new GeoJSON()
  })
})

// https://openlayers.org/en/latest/examples/geojson.html
const droneRestrictions = new VectorLayer({
  style: droneRestrictions_stylesFunction,
  title: 'drone restrictions',
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.bazl.einschraenkungen-drohnen.geojson',
    format: new GeoJSON()
  })
})

const aviationObstacles = new VectorLayer({
  style: styleFunctionObstacles,
  title: 'aviation obstacles',
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.bazl.luftfahrthindernis.geojson',
    format: new GeoJSON()
  })
})

const proNaturaNatureReservates = new VectorLayer({
  style: styleFunction,
  title: 'pronatura nature reservates',
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.pronatura.naturschutzgebiete.geojson',
    format: new GeoJSON()
  })
})

const proNaturaWoodReservates = new VectorLayer({
  style: styleFunction,
  title: 'pronatura wood reservates',
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.pronatura.waldreservate.geojson',
    format: new GeoJSON()
  })
})

const bafuaWoodReservates = new VectorLayer({
  style: styleFunction,
  title: 'bafu wood reservates',
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.bafu.waldreservate.geojson',
    format: new GeoJSON()
  })
})

const mountainAirfields = new VectorLayer({
  style: styleFunctionMountainAirfields,
  title: 'mountain airfields',
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.bazl.gebirgslandeplaetze.geojson',
    format: new GeoJSON()
  })
})

const hospitalLandingFields = new VectorLayer({
  style: styleFunctionHospitalAirFields,
  title: 'hospital landing fields',
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.bazl.spitallandeplaetze.geojson',
    format: new GeoJSON()
  })
})

const airfieldsHeliports = new VectorLayer({
  style: styleFunctionAirFields,
  title: 'airfields-heliports',
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.bazl.flugplaetze-heliports.geojson',
    format: new GeoJSON()
  })
})

const parkingSpotsSource = new TileWMS({
  url: 'https://qgis.bko.li/ogc/dach_parking',
  params: { 'LAYERS': 'dach_parking_all', 'TILED': true },
  serverType: 'geoserver',
  // Countries have transparency, so do not fade tiles:
  transition: 0,
});

const parkingSpots = new TileLayer({
  visible: false,
  title: 'parking spots',
  source: parkingSpotsSource
});

// Extent of the SMAP data bounds 
const imageextent = [5.779211663571768, 45.69079016187699, 10.53772807691217, 47.996394549824288];

const rebuild = false;

const notamDabsToday = new ImageLayer({
  visible: true,
  title: 'notam dabs today',
  opacity: 1.0,
  zIndex: 100,
  source: new Static({
    url: 'data/today_page-0_red_t.png',
    imageExtent: imageextent,
    projection: 'EPSG:4326',
    crossOrigin: ''
  }),
});

const notamDabsTomorrow = new ImageLayer({
  visible: rebuild,
  title: 'notam dabs tomorrow',
  opacity: 1.0,
  zIndex: 99,
  source: new Static({
    url: 'data/tomorrow_page-0_red_t.png',
    imageExtent: imageextent,
    projection: 'EPSG:4326',
    crossOrigin: ''
  }),
});



const baseMaps = new LayerGroup({
  // A layer must have a title to appear in the layerswitcher
  title: 'Base maps',
  layers: [
    swTLM3dBaseLayerSwissTopo, colorBaseLayerSwissTopo, colorBase50LayerSwissTopo, swBaseLayerSwissTopo, swBase50LayerSwissTopo, swWinterLayerSwissTopo, clrTLM3dBaseLayerSwissTopo
  ]
});

const wildRuheZonen = new VectorLayer({
  style: function (feature) {
    return new Style({
      stroke: new Stroke({ color: '#8B4513', width: 1 }),
      fill: new Fill({ color: 'rgba(139, 69, 19, 0.3)' }),
    });
  },
  title: 'Wildlife Rest Zones',
  visible: false,
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: 'data/ch.bafu.wrz-wildruhezonen_portal.geojson',
    format: new GeoJSON()
  })
})

const protectionAreas = new VectorLayer({
  style: protectionAreaStyleFunction,
  title: 'Protection Areas (Ampel)',
  visible: false,
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: `data/protection_areas.geojson?t=${Math.floor(Date.now()/60000)}`,
    format: new GeoJSON()
  })
})

const communityReports = new VectorLayer({
  style: communityReportStyleFunction,
  title: 'Community Reports',
  visible: false,
  source: new VectorSource({
    projection: 'EPSG:4326',
    url: `data/community_reports.geojson?t=${Math.floor(Date.now()/60000)}`,
    format: new GeoJSON()
  })
})

const natureLayers = new LayerGroup({
  visible: false,
  title: 'Nature and forest reserves',
  layers: [wildRuheZonen, proNaturaNatureReservates, proNaturaWoodReservates, bafuaWoodReservates]
});

const communityLayers = new LayerGroup({
  visible: false,
  title: 'Community',
  layers: [communityReports]
});

const aviationLayers = new LayerGroup({
  visible: false,
  title: 'Aviation',
  layers: [mountainAirfields, hospitalLandingFields, airfieldsHeliports]
});

const otherLayers = new LayerGroup({
  title: 'Layers',
  layers: [natureLayers, communityLayers, aviationLayers, parkingSpots, aviationObstacles, localMunicipalityRestrictions, localUasZones, droneRestrictions, easyFlyZone150, easyFlyZone30, protectionAreas, notamDabsTomorrow, notamDabsToday]
});

function getLayerTitle(layer) {
  return layer.get && layer.get('title');
}

function forEachTitledLayer(layerOrGroup, callback) {
  const title = getLayerTitle(layerOrGroup);
  if (title) {
    callback(layerOrGroup, title);
  }

  const childLayers = layerOrGroup.getLayers && layerOrGroup.getLayers();
  if (!childLayers) return;

  childLayers.forEach((childLayer) => forEachTitledLayer(childLayer, callback));
}

function getStoredLayerSelection() {
  try {
    const raw = window.localStorage.getItem(LAYER_SELECTION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    console.warn('Could not read stored layer selection', error);
    return null;
  }
}

function saveLayerSelection(rootLayers) {
  const layers = {};
  rootLayers.forEach((rootLayer) => {
    forEachTitledLayer(rootLayer, (layer, title) => {
      layers[title] = layer.getVisible();
    });
  });

  try {
    window.localStorage.setItem(LAYER_SELECTION_STORAGE_KEY, JSON.stringify({
      version: 1,
      updatedAt: new Date().toISOString(),
      layers,
    }));
  } catch (error) {
    console.warn('Could not store layer selection', error);
  }
}

function restoreLayerSelection(rootLayers) {
  const storedSelection = getStoredLayerSelection();
  if (!storedSelection || !storedSelection.layers) return;

  rootLayers.forEach((rootLayer) => {
    forEachTitledLayer(rootLayer, (layer, title) => {
      if (Object.prototype.hasOwnProperty.call(storedSelection.layers, title)) {
        layer.setVisible(Boolean(storedSelection.layers[title]));
      }
    });
  });
}

function persistLayerSelection(rootLayers) {
  let restoreInProgress = true;
  let saveTimeout = null;

  restoreLayerSelection(rootLayers);
  window.setTimeout(() => {
    restoreInProgress = false;
  }, 0);

  rootLayers.forEach((rootLayer) => {
    forEachTitledLayer(rootLayer, (layer) => {
      layer.on('change:visible', () => {
        if (restoreInProgress) return;
        window.clearTimeout(saveTimeout);
        saveTimeout = window.setTimeout(() => saveLayerSelection(rootLayers), 100);
      });
    });
  });
}

const swissCantons = new VectorLayer({
  source: new VectorSource({
    url: 'data/ch_cantons.geojson',
    format: new GeoJSON(),
  }),
  style: new Style({
    stroke: new Stroke({ color: 'rgba(255,255,255,0.5)', width: 0.7 }),
    fill: new Fill({ color: 'rgba(0,0,0,0)' }),
  }),
  zIndex: 50,
});

const swissBorder = new VectorLayer({
  source: new VectorSource({
    url: 'data/ch_border.geojson',
    format: new GeoJSON(),
  }),
  style: new Style({
    stroke: new Stroke({ color: 'rgba(255,255,255,0.85)', width: 1.5 }),
    fill: new Fill({ color: 'rgba(0,0,0,0)' }),
  }),
  zIndex: 51,
});

var map = new Map({
  target: 'map',
  view: new View({
    projection: "EPSG:3857",
    // constrainResolution: true,
    // center: fromLonLat([longitude, latitude]),
    center: coords,
    zoom: lastZoom
  }),
  layers: [baseMaps, otherLayers, swissCantons, swissBorder],
  controls: defaultControls().extend([
    new ScaleLine({
      units: "metric"
    })
  ]),
});

persistLayerSelection([baseMaps, otherLayers]);


// map.addOverlay(parkingSpots);
let resolution = map.getView().getResolution();
// overlay.setPosition([center[0] + 0*resolution, center[1] + 300*resolution]); 


const layerSwitcher = new LayerSwitcher({
  reverse: true,
  groupSelectStyle: 'group'
});
map.addControl(layerSwitcher);

initCommunityReport(map);

// Protection Areas legend — bottom-left, above scale line, visible only when layer is on
const ampelLegendEl = document.createElement('div');
ampelLegendEl.className = 'ol-control ol-ampel-legend';
ampelLegendEl.innerHTML = `
  <div class="al-title">Protection Areas (Ampel)</div>
  <div class="al-row"><span class="al-swatch" style="background:rgba(220,38,38,0.3);border-color:rgba(220,38,38,0.9)"></span><span><b>Red</b> — No-fly / bird &amp; hunting reserves</span></div>
  <div class="al-row"><span class="al-swatch" style="background:rgba(234,88,12,0.22);border-color:rgba(234,88,12,0.9)"></span><span><b>Orange</b> — Sensitive (moors, floodplains, amphibians)</span></div>
  <div class="al-row"><span class="al-swatch" style="background:rgba(202,138,4,0.18);border-color:rgba(202,138,4,0.9)"></span><span><b>Yellow</b> — Care zone (forest &amp; nature reserves)</span></div>
  <hr class="al-sep">
  <div class="al-desc">
    <b>Sources:</b> BAFU federal inventories (bird reserves, hunting bans, moors, floodplains,
    amphibian areas, wildlife rest zones), ProNatura nature &amp; forest reserves, BAFU forest reserves,
    and cantonal forest reserves for 23 of 26 cantons via geodienste.ch.<br><br>
    <b>⚠ Note:</b> Drone-specific rules are not standardised across these areas. Many regions
    carry no explicit flight ban — always verify local regulations and consult the landowner
    or cantonal authority before flying.
  </div>
`;
ampelLegendEl.style.display = 'none';
map.addControl(new Control({ element: ampelLegendEl }));

protectionAreas.on('change:visible', () => {
  ampelLegendEl.style.display = protectionAreas.getVisible() ? '' : 'none';
});


// const hideTxt = document.getElementById('hide_txt').onclick = function() {
//   document.getElementById("landing").style.display = "none";
//   document.getElementById("map").style.top = "75px";
//   document.getElementById('hide_txt').style.display = "none";
//   map.updateSize();
// }

// *************************************************************************//
// Layer Popup and Infos                                                    //
// https://codesandbox.io/s/popup-forked-jm19g?file=/main.js                //
// *************************************************************************//
let popup = document.getElementById('popup');

const popupOverlay = new Overlay({
  element: popup,
  offset: [9, 9],
  autoPan: { animation: { duration: 250 } },
});

map.addOverlay(popupOverlay);



async function getDataFromGeoAdmin(point, cWidth, cHeight, layername, extent) {
  var url = ` https://api3.geo.admin.ch/rest/services/all/MapServer/identify?geometry=${point}&returnGeometry=false&geometryType=esriGeometryPoint&imageDisplay=${cWidth},${cHeight},96&lang=fr&layers=all:${layername}&mapExtent=${extent}&tolerance=5&sr=3857`
  console.log(url);

  return await fetch(url)
    .then((response) => response.text())
    .then((html) => {
      // content.innerHTML = html;
      // console.log(html);
      return html;
    });
}

map.on('click', (event) => {
  console.log('move');
  selectWeatherLocation(event.coordinate);
  let features = [];
  const valuesToShow = [];
  map.forEachFeatureAtPixel(event.pixel,
    (feature, layer) => {
      // console.log(feature)  
      //console.log(layer);
      features = feature.values_;
      // console.log(features);
      // console.log(typeof(features));
      var txt;

      if (layer.values_.title === localUasZones.values_.title) { // 'Local UAS Zones'
        const name = feature.values_['zone_name_' + lang] || feature.values_.zone_name_en;
        const validity = feature.values_['zone_message_' + lang];
        const description = feature.values_['zone_restriction_' + lang];
        const timeStart = (feature.values_.time_start || '').slice(0, 10);
        const timeEnd = (feature.values_.time_end || '').slice(0, 10);
        const altInfo = feature.values_.air_vol_upper_limit
          ? `Up to: ${feature.values_.air_vol_upper_limit}`
          : '';
        const contact = feature.values_.auth_contact || '';
        const detection = feature.values_.auth_service_en || '';

        txt = `<b>${name}</b>`;
        if (validity) txt += `<br><small>${validity}</small>`;
        if (timeStart || timeEnd) txt += `<br><small>${timeStart} &ndash; ${timeEnd}</small>`;
        txt += `<hr style="border-top: dotted 2px;" /><small>`;
        if (description) txt += `${description}<br>`;
        if (altInfo) txt += `${altInfo}<br>`;
        if (detection) txt += `Detection: ${detection}<br>`;
        if (contact) txt += `Contact: ${contact}`;
        txt += `</small>`;

        valuesToShow.push(txt);
      }

      if (layer.values_.title === localMunicipalityRestrictions.values_.title) {
        const name = feature.values_['zone_name_' + lang] || feature.values_.zone_name_en;
        const message = feature.values_['zone_message_' + lang] || '';
        const description = feature.values_['zone_restriction_' + lang] || '';
        const sourceUrl = feature.values_['auth_url_' + lang] || feature.values_.source_url || '';
        const confidence = feature.values_.source_confidence ? `Confidence: ${Math.round(feature.values_.source_confidence * 100)}%` : '';

        txt = `<b>${name}</b>`;
        if (message) txt += `<br><small>${message}</small>`;
        txt += `<hr style="border-top: dotted 2px;" /><small>`;
        if (description) txt += `${description}<br>`;
        if (confidence) txt += `${confidence}<br>`;
        if (sourceUrl) txt += `<a href="${sourceUrl}" target="_blank" style="color:#7ec8e3;">${sourceUrl}</a>`;
        txt += `</small>`;

        valuesToShow.push(txt);
      }

      if (layer.values_.title === droneRestrictions.values_.title) {

        let days = feature.values_.auth_intervalbefore.replace('P', '').replace('DT', 'D').replace('D', 'days').replace('H', 'hours')
        if (days.trim() != '') {
          days = `Min. ${days} before.`
        }

        txt = `<b>${feature.values_['zone_name_' + lang]}</b><br>${feature.values_['zone_restriction_' + lang]}<br><hr style="border-top: dotted 2px;" />` +
          `<small>${feature.values_['zone_message_' + lang]} &nbsp; ${days}<br>${feature.values_['auth_name_' + lang]}` +
          `<br><a href="${feature.values_['auth_url_' + lang]}" target="_blank" style="color:#7ec8e3;">${feature.values_['auth_url_' + lang]}</a>`

        const optionalFeatures = [feature.values_.auth_contact, feature.values_.auth_service_en, feature.values_.auth_email, feature.values_.auth_phone]

        for (const ftr of optionalFeatures) {
          if (ftr.trim() !== "") {
            txt += `<br>${ftr}`
          }
        }
        txt += `</small>`

        valuesToShow.push(txt);
      }
      if (layer.values_.title === aviationObstacles.values_.title) {
        txt = `<b>${feature.values_.obstacletype}</b><br>Height: ${feature.values_.maxheightagl} m`;
        valuesToShow.push(txt);
      }
      if (layer.values_.title === wildRuheZonen.values_.title) {
        const name = feature.values_.wrz_name || feature.values_.label || '';
        const canton = feature.values_.kanton || '';
        const period = feature.values_.schutzzeit || '';
        const rules = feature.values_.best_de || '';
        const basis = feature.values_.grundlage || '';
        const url = feature.values_.url_kanton || '';
        const status = feature.values_.schutzs_de || '';

        txt = `<b>${name}</b> <small>(${canton})</small>`;
        if (period) txt += `<br><small>Protected: ${period}</small>`;
        txt += `<hr style="border-top: dotted 2px;" /><small>`;
        if (rules) txt += `${rules}<br>`;
        if (status) txt += `Status: ${status}<br>`;
        if (basis) txt += `Basis: ${basis}<br>`;
        if (url) txt += `<a href="${url}" target="_blank" style="color:#7ec8e3;">${canton} map</a>`;
        txt += `</small>`;
        valuesToShow.push(txt);
      }

      if (layer.values_.title === proNaturaNatureReservates.values_.title) {
        txt = `<b>Nature reserve ${feature.values_.label}</b><br>`;
        valuesToShow.push(txt);
      }
      if (layer.values_.title === proNaturaWoodReservates.values_.title) {
        txt = `<b>Wood reserve ${feature.values_['mcpfe_class_' + lang]}</b><br>`;
        valuesToShow.push(txt);
      }
      if (layer.values_.title === bafuaWoodReservates.values_.title) {
        txt = `<b>Wood reserve ${feature.values_.name}</b><br>${feature.values_['mcpfe_class_' + lang]}<br>`;
        valuesToShow.push(txt);
      }
      if (layer.values_.title === mountainAirfields.values_.title) {
        txt = `<b>Mountain airfield: ${feature.values_.icao} - ${feature.values_.name}</b><br>`;
        valuesToShow.push(txt);
      }
      if (layer.values_.title === hospitalLandingFields.values_.title) {
        txt = `<b>Hospital landing fields: ${feature.values_.label}</b><br>`;
        valuesToShow.push(txt);
      }
      if (layer.values_.title === airfieldsHeliports.values_.title) {
        txt = `<b>Airfield / Heliport: ${feature.values_.icao} - ${feature.values_.name}</b><br>`;
        valuesToShow.push(txt);
      }

      if (layer.values_.title === protectionAreas.values_.title) {
        const signal   = feature.values_.signal || 'yellow';
        const nameKey  = 'name_' + lang;
        const name     = feature.values_[nameKey] || feature.values_.name_de || feature.values_.source_id || '';
        const category = (feature.values_.category || '').replace(/_/g, ' ');
        const colors   = { red: '#DC2626', orange: '#EA580C', yellow: '#CA8A04' };
        const color    = colors[signal] || colors.yellow;
        txt = `<b style="color:${color}">&#9632; ${name}</b>`;
        if (category) txt += `<br><small>${category}</small>`;
        txt += `<br><small style="color:${color};text-transform:uppercase;font-weight:bold;">${signal}</small>`;
        valuesToShow.push(txt);
      }

      if (layer.values_.title === communityReports.values_.title) {
        const reportType = (feature.values_.report_type || 'report').replace(/_/g, ' ');
        const status     = feature.values_.status || 'unverified';
        const comment    = feature.values_.comment || '';
        const trust      = feature.values_.trust_score != null ? `Trust: ${feature.values_.trust_score}` : '';
        const statusColors = { verified: '#15803D', confirmed: '#CA8A04', unverified: '#6B7280' };
        const color = statusColors[status] || statusColors.unverified;
        txt = `<b style="color:#7C3AED">&#128681; ${reportType}</b>`;
        txt += `<br><small style="color:${color};font-weight:bold;">${status}</small>`;
        if (comment) txt += `<br><small>${comment}</small>`;
        if (trust)   txt += `<br><small style="color:#6B7280;">${trust}</small>`;
        valuesToShow.push(txt);
      }

    },
    {
      layerFilter: (layer) => {
        return (layer.type === new VectorLayer().type) ? true : false;
      }, hitTolerance: 6
    }
  );
  if (!features || features.length === 0) {
    popup.innerHTML = '';
    popup.hidden = true;
  }
  else {
    popup.innerHTML = `<button style="position:absolute;top:4px;right:6px;background:rgba(255,255,255,0.1);border:none;border-radius:50%;color:#7ec8e3;cursor:pointer;width:22px;height:22px;font-size:0.85em;line-height:22px;text-align:center;" onclick="document.getElementById('popup').hidden=true">✕</button><div style="padding-right:24px">${valuesToShow.join('<hr size="3"><br>')}</div>`;
    popup.hidden = false;
    popupOverlay.setPosition(event.coordinate);
  }


});




var appFeatureVisible = false;


map.on('postrender', function (e) {

  if ((parkingSpots.getVisible() || notamDabsTomorrow.getVisible()) && !appFeatureVisible) {
    appFeatureVisible = true;
    showHideAppFeature();
  }
  if (!parkingSpots.getVisible() && !notamDabsTomorrow.getVisible()) {
    appFeatureVisible = false;
    showHideAppFeature();
  }
});


function showHideAppFeature() {
  if (appFeatureVisible) {
    document.getElementById('app_feature').style.display = 'block';
  }
  else {
    document.getElementById('app_feature').style.display = 'none';
    parkingSpots.setVisible(false);
    notamDabsTomorrow.setVisible(false);
  }
}

document.getElementById('closeAppFeature').onclick = function () {
  document.getElementById('app_feature').style.display = 'none';
  parkingSpots.setVisible(false);
  notamDabsTomorrow.setVisible(false);
};

initWeather(map);

const weatherBtn = document.createElement('button');
weatherBtn.id = 'weather-map-btn';
weatherBtn.title = 'Weather';
document.getElementById('map').appendChild(weatherBtn);
weatherBtn.addEventListener('click', (event) => {
  event.stopPropagation();
  toggleWeather();
  weatherBtn.classList.toggle('weather-open');
});
